<template>
    <div class="nav"><img class="ml546" src="../assets/logo-jiejin.png"/><span class="home-tab hv" @click="navActiveEvent(1)">首页</span><span class="aboutUs-tab hv" ref="aboutUs-tab hv" @click="navActiveEvent(2)">关于我们</span><span class="help-tab hv" @click="navActiveEvent(3)">帮助中心</span></div>
</template>

<script>
export default {
  name: 'Nav',
  props: {
  },
  methods: {
    navActiveEvent(type) {
      const url = type == 2 ? '/AboutUS' : type == 3 ? '/HelpCenter' : '/';
      this.$router.push({ path: url });
    },

  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
  @media screen and (min-width: 800px) {
    .nav {
      //color: #332F2B;
      height: 100px;
      line-height: 100px;
      a {
        text-decoration: none;
        //color: #332F2B
      }
      .ml546 {
        margin-left: 28.44%;
        float: left;
        margin-top: 31px;
      }
      .home-tab {
        margin-left: 25.93%;
      }
      .aboutUs-tab {
        margin-left: 3.38%;
      }
      .help-tab {
        margin-left: 3.38%;
      }
        .hv:hover{
            cursor: pointer;
            color:rgb(242, 151, 0);
        }

    }
  }
    @media screen and (max-width: 800px){
      .nav {
        //color: #332F2B;
        height: 100px;
        line-height: 100px;
        a{
          text-decoration: none;
          //color: #332F2B
        }
        .ml546 {
          margin-left: 1%;
          float: left;
          margin-top: 31px;
        }
        .home-tab {
          margin-left: 3.38%;
        }
        .aboutUs-tab {
          margin-left: 3.38%;
        }
        .help-tab {
          margin-left: 3.38%;
        }

      }
    }
</style>
